import { Box, List, useTheme } from '@mui/material';
import { Heading } from '../Heading/Heading';
import { Total } from '../Total/Total';
import { totalsMapper } from '../../helpers/totalsMapper';
import { sortData } from '../../utils/sortData';
import { totalsNoTotalMessageSx } from './Totals.style';
import { Copy } from '../../copy/Copy';
import { Text } from '../Text/Text';
import { maxWidth345CenteredSx } from '../../styles/Global.style';

export const Totals = ({ userData }) => {
  const theme = useTheme();
  const mappedTotals = totalsMapper(userData);

  return (
    <Box component="section" sx={maxWidth345CenteredSx}>
      <Heading
        text={Copy.generate('Totals.heading')}
        color={theme.palette.secondary.main}
        level={1}
      />

      {userData?.totalDistance !== 0 ? (
        <List>
          {sortData(mappedTotals, 'distance').map(
            (t, i) =>
              t.distance > 0 && (
                <Total
                  key={i}
                  activity={t.activity}
                  distance={t.distance}
                  icon={t.icon}
                  calories={t.calories.toFixed(0)}
                />
              ),
          )}
        </List>
      ) : (
        <Box component="div" sx={totalsNoTotalMessageSx(theme)}>
          <Text text={Copy.generate('Totals.noTotals')} />
        </Box>
      )}
    </Box>
  );
};
